import { __makeTemplateObject } from "tslib";
import React from 'react';
import styled from 'styled-components';
var StyledEllipsis = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  text-align: center;\n  align-items: center;\n  padding: 0 8px;\n"], ["\n  display: inline-flex;\n  text-align: center;\n  align-items: center;\n  padding: 0 8px;\n"])));
export default function renderEllipsis(_a) {
    var key = _a.key;
    return React.createElement(StyledEllipsis, { key: key }, "...");
}
var templateObject_1;
//# sourceMappingURL=renderEllipsis.js.map